import { groupBy, isArray, isEmpty } from 'lodash';

import {
  DOMUI_CLUB_DISTRICT_DATA,
  SITECORE_INDIVIDUAL_TOKEN,
} from '../constants';

import { addLocalisationToPath } from '@utils/localized-navigate';

const MembershipType = {
  Honorary: 'Honorary',
  Member: 'Member',
  RotaractHonorary: 'Rotaract Honorary',
  Rotaractor: 'Rotaractor',
};

export function getSiteCoreIndividualToken() {
  const individual = window.localStorage.getItem(SITECORE_INDIVIDUAL_TOKEN);
  return individual !== 'undefined' && !!individual
    ? JSON.parse(individual)
    : {};
}

export function getClubDistrictFromLocal() {
  const getClubDistrictData = window.localStorage.getItem(
    DOMUI_CLUB_DISTRICT_DATA
  );
  return getClubDistrictData !== 'undefined' && !!getClubDistrictData
    ? JSON.parse(getClubDistrictData)
    : {};
}

// eslint-disable-next-line camelcase
export async function MyRotary_getTokens() {
  let clubName;
  let clubGUID;
  let districtID;
  let districtName;

  // Fetching individual id from local storage.
  const individual = getClubDistrictFromLocal();

  const {
    clubs = [],
    districts = [],
    profileInfo = {},
    individualInfo = {},
    logOutUrl,
    districtLabel = '',
  } = individual;

  // Get Club Info
  const flattedClubs = clubs.flat();
  const clubsOnly = flattedClubs.filter(item => item?.type !== 'District');
  if (!isEmpty(clubsOnly) && isArray(clubsOnly)) {
    const { id, name: firstClubName, formattedClubType } = clubsOnly[0] || {};
    clubName = `${firstClubName} (${formattedClubType})`;
    clubGUID = id;
  }

  // Get District Info
  const flattenedDistricts = districts.flat();
  if (
    individualInfo?.id &&
    !isEmpty(flattenedDistricts) &&
    isArray(flattenedDistricts)
  ) {
    const { id, riDistrictId } = flattenedDistricts[0] || {};
    districtID = id;
    districtName = `${districtLabel} ${riDistrictId}`;
  }

  // Get Individual Profile
  const { firstName, lastName, middleName, fullName, userRole } = profileInfo;

  let formattedLogoutURL = null;
  if (logOutUrl) {
    const isHttpURL =
      logOutUrl.indexOf('http://') === 0 || logOutUrl.indexOf('https://') === 0;
    formattedLogoutURL = isHttpURL ? logOutUrl.split('//')[1] : logOutUrl;
  }

  const individualToken = individualInfo?.id
    ? {
        'primary-club-guid': clubGUID || '',
        'primary-club-text': clubName || '',
        'primary-district-guid': districtID || '',
        'primary-district-text': districtName || '',
        'member-id': individualInfo?.id,
        'user-firstname': firstName || '',
        'user-lastname': lastName || '',
        'user-middlename': middleName || '',
        'user-fullname': fullName || '',
        'user-role': userRole || '',
        'logout-url': formattedLogoutURL || '',
      }
    : {};

  return individualToken;
}

// eslint-disable-next-line camelcase
export async function MyRotary_getAllClubs() {
  const individual = getClubDistrictFromLocal();
  const { clubs = [], weekDayLabels } = individual;
  const flattedClubs = clubs.flat();
  const clubsOnly = flattedClubs.filter(item => item.type !== 'District');
  if (!isEmpty(flattedClubs) && isArray(flattedClubs)) {
    return clubsOnly.map(club => {
      const {
        id: clubId,
        name: firstClubName,
        formattedClubType,
        district = {},
        affiliation = [],
        meetings = [],
      } = club;

      const districtGuid =
        !isEmpty(district) && Array.isArray(district) ? district[0]?.id : '';

      const appUrl = process.env.MRX_APP_PUBLIC_URL ?? '';
      const clubUrl = `${appUrl}${addLocalisationToPath(
        `/domui/club/${clubId}/details`
      )}`;
      const isPrimary = affiliation.some(
        a =>
          a.role === MembershipType.Member ||
          a.role === MembershipType.Rotaractor
      );

      const meetingDetails = meetings[0];

      const clubToken = {
        'club-guid': clubId,
        'club-text': `${firstClubName} (${formattedClubType})`,
        'club-url': clubUrl,
        'is-primary': isPrimary,
        'district-guid': districtGuid,
      };

      if (
        !isEmpty(meetingDetails) &&
        !!meetingDetails.weekday &&
        !!meetingDetails.time
      ) {
        clubToken['next-meeting-details'] = [
          `${weekDayLabels[meetingDetails.weekday]} ${meetingDetails.time}`,
        ];
      }

      return clubToken;
    });
  }
}
// eslint-disable-next-line camelcase
export async function MyRotary_getAllDistrcits() {
  const individual = getClubDistrictFromLocal();
  const { districts = [], clubs = [], districtLabel = '' } = individual;

  const clubsWithVaildDistrict =
    !isEmpty(clubs) &&
    isArray(clubs) &&
    clubs.filter(club => isArray(club.district) && !isEmpty(club.district));

  const groupedDistricts =
    !isEmpty(clubsWithVaildDistrict) && isArray(clubsWithVaildDistrict)
      ? groupBy(clubsWithVaildDistrict, 'district[0].id')
      : [];
  const flattenedDistricts = districts.flat();
  if (!isEmpty(flattenedDistricts) && isArray(flattenedDistricts)) {
    return flattenedDistricts.map(district => {
      const { id, riDistrictId, isHomeDistrict, zone } = district;
      const appUrl = process.env.MRX_APP_PUBLIC_URL ?? '';
      const districtUrl = `${appUrl}${addLocalisationToPath(
        `/domui/district/${id}/details`
      )}`;

      const clubsByDistrict = !isEmpty(groupedDistricts)
        ? groupedDistricts[id]?.map(club => club.id)
        : [];

      const districtToken = {
        'district-guid': id,
        'district-text': `${districtLabel} ${riDistrictId}`,
        'district-url': districtUrl,
        'is-primary': isHomeDistrict,
        'district-number': riDistrictId,
        'zone-number': zone,
        clubs: clubsByDistrict,
      };
      return districtToken;
    });
  }
}
